var APP_ROUTES = [
    {
        path: '',
        loadChildren: './pages/pages.module#PagesModule',
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];
var AppRoutingModule = (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/app.routing.ts.pre-build-optimizer.js